<template>
  <!-- <a-spin :spinning="confirmLoading"> -->
    <!-- <j-form-container :disabled="formDisabled"> -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="班级名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['gradeName']" placeholder="请输入班级名称"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <!-- (1-字典选择，2-少儿国画、3-西方油画、4-素描、5-动漫插画、6-线描写生) -->
            <a-form-item label="所属课程" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-decorator="[
                `courseId`,
                {rules: [{ required: true, message: '请选择所属课程'}]},
              ]" placeholder="请选择所属课程">
                <a-select-option v-for="(item,i) in myCourseList" :key="i" :value="item.id">{{item.courseName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="班级人员容量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['gradeCapacity']" placeholder="请输入班级人员容量" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="班级教师" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['gradeTeacherIds']" placeholder="请选择班级教师"  ></a-input> -->
              <a-select mode="multiple" v-decorator="[
                `gradeTeacherIds`,
                {rules: [{ required: true, message: '请选择班级教师'}]},
              ]" placeholder="请选择班级教师">
                <a-select-option v-for="(item,i) in myTeacherList" :key="i" :value="item.id">{{item.realname}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['gradeRemark']" rows="4" placeholder="请输入备注" />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-item label="创建人ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['createBy']" placeholder="请输入创建人ID"  ></a-input>
            </a-form-item>
          </a-col> -->
          <!-- <a-col :span="24">
            <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择创建时间" v-decorator="['createTime']" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col> -->
          <!-- <a-col :span="24">
            <a-form-item label="修改人ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['updateBy']" placeholder="请输入修改人ID"  ></a-input>
            </a-form-item>
          </a-col> -->
          <!-- <a-col :span="24">
            <a-form-item label="修改时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择修改时间" v-decorator="['updateTime']" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col> -->
          <!-- <a-col :span="24">
            <a-form-item label="删除标识0-正常,1-已删除" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['delFlag']" placeholder="请输入删除标识0-正常,1-已删除" style="width: 100%" />
            </a-form-item>
          </a-col> -->
          <!-- <a-col :span="24">
            <a-form-item label="Saas码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sysSign']" placeholder="请输入Saas码"  ></a-input>
            </a-form-item>
          </a-col> -->
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    <!-- </j-form-container> -->
  <!-- </a-spin> -->
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { queryUserCourse, getAllTeacherList} from '@/api/api'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  // import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: 'ElinkxGradeForm',
    components: {
      // JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        myCourseList:[],
        myTeacherList:[],
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/grade/add",
          edit: "/grade/edit",
          queryById: "/grade/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.queryUserCourse();
      this.getAllTeacherList();
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.model['gradeTeacherIds'] = this.model['gradeTeacherIds'].split(',');
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'gradeName','courseId','gradeCapacity','gradeTeacherIds','gradeRemark','createBy','createTime','updateBy','updateTime','delFlag','sysSign'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            formData['gradeTeacherIds'] = formData['gradeTeacherIds'].join(',') ;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'gradeName','courseId','gradeCapacity','gradeTeacherIds','gradeRemark','createBy','createTime','updateBy','updateTime','delFlag','sysSign'))
      },
      queryUserCourse(){
        queryUserCourse().then((res)=>{
          if(res.success){
            this.myCourseList = res.result || [];
          }else{
            this.$message.warning(res.message);
          }
        }).finally(() => {
          this.confirmLoading = false;
        })
      },
      getAllTeacherList(){
        getAllTeacherList().then((res)=>{
          if(res.success){
            this.myTeacherList = res.result || [];
          }else{
            this.$message.warning(res.message);
          }
        }).finally(() => {
          this.confirmLoading = false;
        })
      }
    }
  }
</script>